import { create } from "zustand"

interface InquiryLandingStore {
  hospitalName: string
  userName: string
  phone: string
  setHospitalName: (hospitalName: string) => void
  setUserName: (userName: string) => void
  setPhone: (phone: string) => void
  reset: () => void
}

const useInquiryLandingStore = create<InquiryLandingStore>((set) => ({
  hospitalName: "",
  userName: "",
  phone: "",
  setHospitalName: (hospitalName: string) => set({ hospitalName }),
  setUserName: (userName: string) => set({ userName }),
  setPhone: (phone: string) => set({ phone }),
  reset: () => set({ hospitalName: "", userName: "", phone: "" }),
}))

export default useInquiryLandingStore
